class HaliLieferinfo extends HTMLElement {
  connectedCallback() {
    this._section = this.closest('.shopify-section, dialog');
    this._handler = (event) => {
      // Bundle-Platzhalter: Inhalt und _liefertermin-Property setzt hali-bundle-inhalt.js
      // aus den Komponenten; das neu gerenderte HTML wäre hier leer und würde sie löschen.
      if (this.dataset.haliBundle !== undefined) return;
      const newHtml = event.detail?.data?.html;
      if (!newHtml) return;

      const newEl = newHtml.querySelector(
        `hali-lieferinfo[data-block-id="${this.dataset.blockId}"]`
      );
      // Fehlt der Block in der neuen Variante (z. B. ohne Lieferart), leeren statt den
      // alten Zustand (etwa „Ausverkauft“) stehen zu lassen.
      this.innerHTML = newEl ? newEl.innerHTML : '';

      const newInput = newHtml.querySelector('input[name="properties[_liefertermin]"]');
      const input = this._section?.querySelector('input[name="properties[_liefertermin]"]');
      if (input) input.value = newInput?.value ?? '';
    };
    this._section?.addEventListener('variant:update', this._handler);
  }

  disconnectedCallback() {
    this._section?.removeEventListener('variant:update', this._handler);
  }
}

if (!customElements.get('hali-lieferinfo')) {
  customElements.define('hali-lieferinfo', HaliLieferinfo);
}
